/* tslint:disable */
/* eslint-disable */

/**
 * 805290003 = Entwurf (Entwurf)
 * 
 * 1 = Erfasst (Erfasst)
 * 
 * 805290000 = InPrufung (In Prüfung)
 * 
 * 805290001 = Befurwortet (Befürwortet)
 * 
 * 645030001 = Zuruckgezogen (Zurückgezogen)
 * 
 * 805290002 = Projekterstellt (Projekt erstellt)
 * 
 * 2 = Abgelehnt (Abgelehnt)
 * 
 * 401130001 = Storniert (Storniert)
 * 
 * 401130002 = Zuruckgezogen_2 (Zurückgezogen)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode {
 Entwurf = 805290003,
 Erfasst = 1,
 InPrufung = 805290000,
 Befurwortet = 805290001,
 Zuruckgezogen = 645030001,
 Projekterstellt = 805290002,
 Abgelehnt = 2,
 Storniert = 401130001,
 Zuruckgezogen_2 = 401130002
}

marker([
    "Enum.AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode.Entwurf",
    "Enum.AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode.Erfasst",
    "Enum.AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode.InPrufung",
    "Enum.AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode.Befurwortet",
    "Enum.AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode.Zuruckgezogen",
    "Enum.AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode.Projekterstellt",
    "Enum.AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode.Abgelehnt",
    "Enum.AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode.Storniert",
    "Enum.AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode.Zuruckgezogen_2"
]);

export namespace AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode
{
    class DataSets
    {
        static AceProjektideeAceProjektideeEnumsAceProjektideeStatuscodeDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Entwurf", 805290003, "Entwurf"),
            new EnumValue("Erfasst", 1, "Erfasst"),
            new EnumValue("InPrufung", 805290000, "In Prüfung"),
            new EnumValue("Befurwortet", 805290001, "Befürwortet"),
            new EnumValue("Zuruckgezogen", 645030001, "Zurückgezogen"),
            new EnumValue("Projekterstellt", 805290002, "Projekt erstellt"),
            new EnumValue("Abgelehnt", 2, "Abgelehnt"),
            new EnumValue("Storniert", 401130001, "Storniert"),
            new EnumValue("Zuruckgezogen_2", 401130002, "Zurückgezogen"),
        )
    }

    export function getAsDataset() {
        return DataSets.AceProjektideeAceProjektideeEnumsAceProjektideeStatuscodeDataSet;
    }
}
